import { useMemo, useRef } from 'react';

const useVideoThumbnail = () => {
    const cacheRef = useRef({});

    const getThumb = useMemo(
        () => (url) => {
            if (!url) return null;
            const cached = cacheRef.current[url];
            if (cached) return cached;

            const video = document.createElement('video');
            if (typeof url === 'string' && (url.startsWith('http://') || url.startsWith('https://'))) {
                video.crossOrigin = 'anonymous';
            }
            video.muted = true;
            video.preload = 'metadata';
            video.src = url;

            const fail = () => {
                cacheRef.current[url] = { type: 'error' };
            };

            const capture = () => {
                try {
                    const canvas = document.createElement('canvas');
                    const ratio = video.videoWidth / (video.videoHeight || 1);
                    const width = 120 * (ratio >= 1 ? ratio : 1);
                    const height = 120 * (ratio >= 1 ? 1 : 1 / ratio);
                    canvas.width = width;
                    canvas.height = height;
                    const ctx = canvas.getContext('2d');
                    ctx.drawImage(video, 0, 0, width, height);
                    const dataUrl = canvas.toDataURL('image/jpeg', 0.6);
                    cacheRef.current[url] = { type: 'image', src: dataUrl };
                } catch (error) {
                    fail();
                }
            };

            video.addEventListener('error', fail, { once: true });
            video.addEventListener(
                'loadedmetadata',
                () => {
                    try {
                        const midpoint = Math.max(Math.min((video.duration || 0) / 2, (video.duration || 0) - 0.1), 0.1);
                        video.currentTime = midpoint;
                    } catch (error) {
                        fail();
                    }
                },
                { once: true }
            );
            video.addEventListener('seeked', capture, { once: true });

            return null;
        },
        []
    );

    return { getThumb };
};

export default useVideoThumbnail;
